// @flow
import { unauthenticatedFetch } from '../../../api/request';

export default async function getEmailSettings(token: string) {
    return await unauthenticatedFetch(
        `/public/v5/emailSettings?token=${token}`
    );
}
